import { Icon, type IconName } from 'components/ui/icon';

interface NavItemIconProps {
  icon?: IconName;
}

export const NavItemIcon: React.FC<NavItemIconProps> = ({ icon }) => {
  if (!icon) return null;

  return <Icon name={icon} size={20} className="shrink-0" aria-hidden="true" />;
};

NavItemIcon.displayName = 'NavItemIcon';
